import { __ } from '@wordpress/i18n';

/**
 * Calculate buffer
 *
 * @param {number} quantity
 * @return {number}
 */
// const calculateBuffer = (quantity) => {
// 	if (quantity <= 3) {
// 		return quantity;
// 	}

// 	return Math.floor(quantity * 0.8);
// };

const Tooltip = () => {
	return (
		<div className="tooltip">
			<svg
				className="tooltip__icon"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 512 512"
			>
				<title>{__('Sold out info', 'visitedu-block-theme')}</title>
				<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
			</svg>
			<span className="tooltip__text">
				{__(
					'Looks like this course is almost sold out. However we still might be able to fit you into this course. Please contact our office for more information.',
					'visitedu-block-theme'
				)}
			</span>
		</div>
	);
};

/**
 * Get status
 * - Product seats have 20% buffer to make sure that there is enough room to sell tickets
 *   e.g. if inventory is 20, buffer will reduce the amount of available tickets on the frontend to 16
 * - Buffer will start to calculate when there is 10 or less seats available
 * - Buffer will stop when 3 seats available. At his point, show the real inventory amount
 *   (when 3 or less seats are available)
 * @param {object} stock
 * @returns {JSX.Element}
 */
const CourseListItemSeats = ({ stock }) => {
	const { manage_stock, quantity, status } = stock;

	/**
	 * Guard clauses
	 */
	if (!manage_stock) {
		return null;
	}

	if (status !== 'instock') {
		return null;
	}

	if (quantity > 10) {
		return null;
	}

	/**
	 * Render
	 */
	if (quantity <= 0) {
		return (
			<div className="course-list__item__content-seats">
				{__('Sold out', 'visitedu-block-theme')}
			</div>
		);
	}

	return (
		<>
			<div className="course-list__item__content-seats">
				{quantity} {__('seats available', 'visitedu-block-theme')}
				{quantity <= 3 && <Tooltip />}
			</div>
		</>
	);
};

export default CourseListItemSeats;
